import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../config/httpConfig";

export const getDealsByStatus = createAsyncThunk(
  "deal/getDealsByStatus",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `/api/investor/getDealsByStatus`,
        payload,
      );
      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
export const getAllRoiTypes = createAsyncThunk(
  "deal/getAllRoiTypes",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/investor/getAllROI`);
      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
export const getAllMaturityTypes = createAsyncThunk(
  "deal/getAllMaturityTypes",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/investor/getAllMaturity`);
      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
export const getAllRatingTypes = createAsyncThunk(
  "deal/getAllRatingTypes",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/investor/getAllRating`);
      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getAllIndustryTypes = createAsyncThunk(
  "deal/getAllIndustryTypes",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/investor/getAllIndustryTypes`);
      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getAllInterestStatus = createAsyncThunk(
  "deal/getAllInterestStatus",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/investor/interestStatus`);
      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getAllEnterprises = createAsyncThunk(
  "deal/getAllEnterprises",
  async (selectedTab, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `/api/investor/getAllEnterprises?currentStatus=${selectedTab}`,
      );
      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const buyDeal = createAsyncThunk(
  "deal/buyDeal",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.put(`/api/investor/buyDeal`, payload);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const updateDealInterestStatus = createAsyncThunk(
  "deal/updateDealInterestStatus",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `/api/investor/updateDealInterestStatus`,
        payload,
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getDealById = createAsyncThunk(
  "deal/getDealById",
  async (dealId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `/api/investor/getDealById?dealId=${dealId}`,
      );
      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getDealSections = createAsyncThunk(
  "deal/getDealSections",
  async (dealId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `/api/investor/getDealSections?dealId=${dealId}`,
      );
      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getInvestorReports = createAsyncThunk(
  "report/getInvestorReports",
  async ({ orgId, format, type, startDate, endDate }, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/investor/getInvestorReports`, {
        params: {
          orgId,
          type,
          format,
          startDate,
          endDate,
        },
        responseType: "blob", // To handle file response
      });

      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const dealSlice = createSlice({
  name: "deal",
  initialState: {
    dealsData: [],
    deal: [],
    dealSections: [],
    industryTypes: [],
    enterprises: [],
    roi: [],
    rating: [],
    maturity: [],
    reports: "",
    loading: false,
    dealSectionsLoading: false,
    dealSectionsError: null,
    error: null,
    buyDealLoading: false,
    interestStatus: [],
    interestStatusLoading: false,
    interestStatusError: null,
  },

  extraReducers: (builder) => {
    builder.addCase(getDealsByStatus.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getDealsByStatus.fulfilled, (state, action) => {
      state.loading = false;
      state.dealsData = action.payload;
      state.error = null;
    });
    builder.addCase(getDealsByStatus.rejected, (state, action) => {
      state.loading = false;
      state.dealsData = [];
      state.error = action.payload;
    });

    builder.addCase(getAllRoiTypes.fulfilled, (state, action) => {
      state.roi = action.payload;
    });
    builder.addCase(getAllRatingTypes.fulfilled, (state, action) => {
      state.rating = action.payload;
    });

    builder.addCase(getAllMaturityTypes.fulfilled, (state, action) => {
      state.maturity = action.payload;
    });
    builder.addCase(getAllIndustryTypes.fulfilled, (state, action) => {
      state.industryTypes = action.payload;
    });

    builder.addCase(getAllInterestStatus.fulfilled, (state, action) => {
      state.interestStatus = action.payload;
    });

    builder.addCase(getAllEnterprises.fulfilled, (state, action) => {
      state.enterprises = action.payload;
    });

    builder.addCase(buyDeal.pending, (state) => {
      state.buyDealLoading = true;
      state.error = null;
    });
    builder.addCase(buyDeal.fulfilled, (state, action) => {
      state.buyDealLoading = false;
      state.error = null;
    });
    builder.addCase(buyDeal.rejected, (state, action) => {
      state.buyDealLoading = false;
      state.error = action.payload;
    });

    builder.addCase(getDealById.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getDealById.fulfilled, (state, action) => {
      state.loading = false;
      state.deal = action.payload;
      state.error = null;
    });
    builder.addCase(getDealById.rejected, (state, action) => {
      state.loading = false;
      state.deal = null;
      state.error = action.payload;
    });

    builder.addCase(getDealSections.pending, (state) => {
      state.dealSectionsLoading = true;
      state.dealSectionsError = null;
    });
    builder.addCase(getDealSections.fulfilled, (state, action) => {
      state.dealSectionsLoading = false;
      state.dealSections = Array.isArray(action.payload) ? action.payload : [];
      state.dealSectionsError = null;
    });
    builder.addCase(getDealSections.rejected, (state, action) => {
      state.dealSectionsLoading = false;
      state.dealSections = [];
      state.dealSectionsError = action.payload;
    });

    builder.addCase(getInvestorReports.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getInvestorReports.fulfilled, (state, action) => {
      state.loading = false;
      state.reports = action.payload;
      state.error = null;
    });
    builder.addCase(getInvestorReports.rejected, (state, action) => {
      state.loading = false;
      state.reports = null;
      state.error = action.payload;
    });

    builder.addCase(updateDealInterestStatus.pending, (state) => {
      state.interestStatusLoading = true;
      state.interestStatusError = null;
    });
    builder.addCase(updateDealInterestStatus.fulfilled, (state, action) => {
      state.interestStatusLoading = false;
      state.interestStatusError = null;
    });
    builder.addCase(updateDealInterestStatus.rejected, (state, action) => {
      state.interestStatusLoading = false;
      state.interestStatusError = action.payload;
    });
  },
  reducers: {
    resetInterestState: (state) => {
      state.interestStatusError = null;
    },
  },
});

// eslint-disable-next-line no-empty-pattern
export const { resetInterestState } = dealSlice.actions;

export default dealSlice.reducer;
